import React from 'react';
import { contacts, content } from '../../content';
import { BlogPost } from '../../types';
import { formatPostDate, readingTime } from '../../utils/blog';
import { ArrowLeftIcon, ArrowRightIcon } from '../Icon';
import BlogBlocks from './BlogBlocks';
// `.btn` and `.chip` are shared with the sections.
import '../../styles/Sections.css';
import '../../styles/Blog.css';

const { ui } = content;

/**
 * The article itself: one column, capped at a readable measure, with the
 * pictures and the infographics allowed to breathe wider than the text.
 *
 * It is a page rather than a dialog on purpose — an article is something a
 * reader arrives at from outside, keeps open, and sends to someone else, and
 * all three of those want a URL of their own.
 */
const BlogPostView = ({ post, onBack }: { post: BlogPost; onBack: () => void }) => {
  const date = formatPostDate(post.date);

  return (
    <article className="post">
      <button type="button" className="post__back" onClick={onBack}>
        <ArrowLeftIcon size={15} />
        <span>{ui.blogBack}</span>
      </button>

      <header className="post__head">
        <div className="post__meta">
          {date && (
            <time className="post__date" dateTime={post.date}>
              {date}
            </time>
          )}
          <span className="post__dot" aria-hidden>
            ·
          </span>
          <span className="post__reading">{readingTime(post)}</span>
        </div>

        <h1 className="post__title">{post.title}</h1>
        <p className="post__excerpt">{post.excerpt}</p>

        <ul className="post__tags">
          {post.tags.map((tag) => (
            <li key={tag} className="chip">
              {tag}
            </li>
          ))}
        </ul>
      </header>

      {post.cover && (
        <figure className="post__cover">
          <img src={post.cover.src} alt={post.cover.alt} loading="lazy" decoding="async" />
          {post.cover.caption && (
            <figcaption className="post-figure__caption">{post.cover.caption}</figcaption>
          )}
        </figure>
      )}

      <div className="post__body">
        <BlogBlocks blocks={post.body} />
      </div>

      {/* A reader who got to the end is the most interested reader on the
          site. The ask goes here, where they already are. */}
      <footer className="post__outro">
        <p className="post__outro-text">{ui.blogOutro}</p>
        <a className="btn btn--primary" href={contacts.telegram} target="_blank" rel="noreferrer">
          {ui.blogOutroCta}
          <ArrowRightIcon size={15} />
        </a>
      </footer>

      <button type="button" className="post__back post__back--bottom" onClick={onBack}>
        <ArrowLeftIcon size={15} />
        <span>{ui.blogBack}</span>
      </button>
    </article>
  );
};

export default BlogPostView;
